import { MAIN_EMAIL, PORTRAIT } from "@/content";

export const Hero = ({ t }) => (
  <header id="top" className="py-20 md:py-28" data-testid="hero-section">
    <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-[1.1fr_.9fr] gap-12 items-center">
      <div className="min-w-0">
        <p className="lb fu text-brassink">{t.heroLabel}</p>
        <h1 className="dd mt-6" data-testid="hero-heading">
          <span className="sr-only">Jamal Zgugu — </span>
          {t.heroLines.map((line) => (
            <span className="ln" key={line}>
              <span>{line}</span>
            </span>
          ))}
        </h1>
        <p className="fu mt-6 text-[18px] leading-[1.6] max-w-md">{t.heroText}</p>
        <a
          href={`mailto:${MAIN_EMAIL}`}
          className="fu fu2 group sv mt-8 inline-flex items-center gap-3 border-b-2 border-brass pb-2 text-[17px] transition-colors duration-200 hover:text-brass"
          data-testid="hero-contact-button"
        >
          {t.heroCta}
          <span className="transition-transform duration-200 group-hover:translate-x-1 rtl:rotate-180 rtl:group-hover:-translate-x-1">→</span>
        </a>
      </div>
      <div className="px">
        <figure className="wp relative aspect-[4/5] bg-imagebg border border-brass/40 overflow-hidden" data-testid="hero-portrait">
          <img
            src={PORTRAIT}
            alt="Portrait of Jamal Zgugu, intellectual property and trademark protection professional"
            className="absolute inset-0 w-full h-full object-cover object-top mix-blend-multiply"
          />
          <figcaption className="lb absolute bottom-5 start-5 bg-paper/90 px-2 py-1 text-caption">{t.portraitCaption}</figcaption>
        </figure>
      </div>
    </div>
  </header>
);
